
import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Upload } from 'lucide-react';

interface FarmPriceFileUploadProps {
  onFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const FarmPriceFileUpload: React.FC<FarmPriceFileUploadProps> = ({ onFileChange }) => {
  return (
    <div className="border-2 border-dashed border-gray-300 rounded-lg p-6">
      <div className="text-center">
        <Upload className="mx-auto h-12 w-12 text-gray-400" />
        <div className="mt-4">
          <Label htmlFor="file-upload" className="cursor-pointer">
            <span className="text-blue-600 hover:text-blue-500">
              Choose a file
            </span>
            <Input
              id="file-upload"
              type="file"
              accept=".xlsx,.xls"
              onChange={onFileChange}
              className="hidden"
            />
          </Label>
          <p className="text-gray-500">or drag and drop</p>
        </div>
        <p className="text-sm text-gray-500">Excel files only (.xlsx, .xls)</p>
      </div>
    </div>
  );
};

export default FarmPriceFileUpload;
